import type { DocMigration } from "../docMigration";

// eslint-disable-next-line @typescript-eslint/naming-convention
const migration_0_0_103: DocMigration = {
  maxSchemaVersion: "0.0.103",
  description: "Fix integrity issues associated with elevations",
  apply(json: any) {
    if (!json.elevations) {
      return json;
    }

    for (const id in json.elevations) {
      const elevation = json.elevations[id];
      json.elevations = {
        ...json.elevations,
        [id]: {
          ...elevation,
          id,
        },
      };
    }
    return json;
  },
};

export default migration_0_0_103;
